import { GenericLazyString } from '@eventbrite/i18n';
import React from 'react';
import './CategoryScrollTemplate.scss';

interface CategoryScrollTemplate {
    subTitle?: string | GenericLazyString | React.ReactElement;
    title?: string | GenericLazyString | React.ReactElement;
    viewMore?: React.ReactElement;
    wrappingClasses?: string;
}

/**
 * Simple component that will provide consistent spacing
 * between buckets and styling for header titles.
 */
export const CategoryScrollTemplate: React.FunctionComponent<
    CategoryScrollTemplate
> = ({ subTitle, title, viewMore, wrappingClasses = '', children }) => {
    return (
        <section className={`categoryScrollTemplate ${wrappingClasses}`}>
            {title ? (
                <div className="categoryScrollTemplateHeader eds-text-hs">
                    {title}
                </div>
            ) : null}
            {subTitle ? (
                <div className="categoryScrollTemplateSubHeader">
                    {subTitle}
                </div>
            ) : null}
            {viewMore ? (
                <div className="categoryScrollTemplateHeaderViewMore eds-text-bm">
                    {viewMore}
                </div>
            ) : null}
            {children}
        </section>
    );
};
